export const WMS_ROOT = '/wms';

export const WMSRoutes = {
    DASHBOARD: '/wms/dashboard',
    PICKING: '/wms/picking',
    SORTING: '/wms/sorting',
    PACKING: '/wms/packing',
    TRI_SHIPPING: '/wms/triShipping',
    SHIPPING: '/wms/shipping',
    ASSOCIATION: '/wms/associations',
    NEW_MISSION: '/wms/newMission',
    MISSION_MODEL_LIST: '/wms/missionList',
    CC_LIST: '/wms/cc/list',
    CC_HAND_OVER: '/wms/cc/hand-over',
    CC_RECEPTION_LIST: '/wms/ccReception'
}

export const WMSRoutesName = {
    DASHBOARD: 'wms.routes.dashboard',
    PICKING: 'wms.routes.picking',
    SORTING: 'wms.routes.sorting',
    PACKING: 'wms.routes.packing',
    TRI_SHIPPING: 'wms.routes.triShipping',
    SHIPPING: 'wms.routes.shipping',
    ASSOCIATION: 'wms.routes.association',
    CC_LIST: 'wms.routes.ccList',
    CC_HAND_OVER: 'wms.routes.ccHandOver',
    CC_RECEPTION_LIST: "wms.routes.ccReceptionList",
    NEW_MISSION: 'wms.routes.newMission',
    MISSION_MODEL_LIST: 'wms.routes.missionModelList',
}
